(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["auragleam-product-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ag-product-delivery')) {
    customElements.define('ag-product-delivery', class extends HTMLElement {
      constructor() {
        super();
        this.unsubscribers = [];
        this.onReady = this.connectEvents.bind(this);
      }

      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.onReady, { once: true });
        } else {
          this.connectEvents();
        }
      }

      connectEvents() {
        if (this.closest('[data-ag-mm-builder]')) return;
        if (this.unsubscribers.length || !this.isConnected) return;
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

        this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
          const target = data?.event?.target || data?.target;
          const productInfo = this.closest('product-info');
          if (target && productInfo?.contains(target)) this.hidden = true;
        }));

        this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          const sourceSection = this.closest('product-info')?.dataset.originalSection || this.dataset.section;
          if (!data || String(data.sectionId) !== String(sourceSection)) return;
          const source = data.html?.getElementById(`AGDelivery-${sourceSection}`);
          if (!source) {
            this.hidden = true;
            return;
          }
          this.innerHTML = source.innerHTML;
          this.hidden = source.hidden || !data.variant?.available || data.variant?.requires_shipping === false;
        }));
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.onReady);
        this.unsubscribers.forEach(unsubscribe => unsubscribe());
        this.unsubscribers = [];
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
